import React from 'react';
import { formatImage } from '@ifeng-fe/three_terminal/es/base/publicMethod/formatImage';
import PropTypes from 'prop-types';
import styles from './index.css';

const Video = ({ content }) => {
    const { poster } = content;

    if (poster) {
        return (
            <div className={styles.poster}>
                <img src={formatImage(poster, 534, 300)} />
            </div>
        );
    } else {
        return null;
    }
};

Video.propTypes = {
    content: PropTypes.object,
};

export default Video;
